import '../utils/KeyboardEventsUtil';
import {ResolutionHandler} from '../utils/ResolutionHandler';
import {detect} from "detect-browser";

export default class Controller {

  constructor() {
    // ResolutionHandler();
  }

  /**
   * Components that will be always initialized in every controller
   * @returns {string[]}
   * @constructor
   */
  static get BASE_COMPONENTS() {
    let components =  [
      'HistoryManagerComponent',
      'LoginComponent',
      'LoginValidationComponent',
      'RowTwinComponent',
      'MultilineEllipsisComponent',
      'TrackingComponent',
      'ContactUsComponent',
      'CookieComponent',
      'TealiumLinkComponent',
      'LoaderComponent',
      'MenuComponent',
      'FooterComponent',
      'ModalComponent',
      'DropdownComponent',
      'BurgerComponent',
      'SearchComponent',
      'BackdropComponent',
      'AddToCartComponent',
      'MiniWishlistComponent',
      'MiniCartComponent',
      'MiniProfileComponent',
      'ResetPwComponent',
      'AddToWishlistComponent',
      'StickyComponent',
      'CollapseComponent',
      'FixedMediaComponent',
      'SelectComponent',
      'BenefitBarComponent',
      'NewsletterComponent',
      'NewsletterPopoverComponent',
      'ShowPasswordComponent',
      'HeaderComponent',
      'DataShowComponent',
      'CarouselComponent',
      'TooltipCvvComponent',
      'TooltipComponent',
      'GlobalMessagesComponent',
      'DataLinkComponent',
      'NewPrivacyComponent',
      'NewPrivacyKoreaComponent',
      'PrivacyUnsubscribe',
      'TippyComponent',
      'TabsComponent',
      'QuickBuyComponent',
      'OnEnterInViewportComponent',
      'ShowMoreComponent',
      'PrivacyPreference',
      'RecommendationEngineComponent',
      'PreventDoubleClick',
      'ChatComponent',
      'UpperCaseComponent'
    ];


    // return all the components
    return components;
  }

  setBrowserAttributes(obj) {
    return new Promise((resolve, reject) => {
      try {
        for (let key of Object.keys(obj)) {
          document.documentElement.setAttribute(`data-browser-${key}`, obj[key]);
        }
        resolve(true);
      } catch (e) {
        reject(e);
      }
    });
  }

  /**
   * Log utility
   * @param logStr
   */
  log(logStr = '') {
    if (logStr != '') {
      let myName = this.constructor.name;
      console.debug(`[${myName}] ${logStr}`);
    }
  }

  /*
   *  Initialization logic of the page
   */
  init() {
    this.log('Initializing..');
    // const browser = detect();
    if (detect()) this.setBrowserAttributes(detect()).then(res => { console.debug('Browser data saved') });

    ResolutionHandler();

    try {
      // Dynamic init of components related to a controller
      let componentsToRender = [...new Set(Controller.BASE_COMPONENTS.concat(this.constructor.COMPONENTS))];
      this.log(`Rendering ${componentsToRender}`);
      for (let component of componentsToRender) {
        import(/* webpackChunkName: `components-[request]` */ `../components/${component}`).then((module) => {
          let DynamicComponent = module.default; // we except that the component is the the default attribute of the module
          let dynamicComponent = new DynamicComponent();
          dynamicComponent.render();
        }).catch(error => {
          console.error('Failed to load the component', error.stack);
        });
      }
    } catch (error) {
      console.error('Failed to iterate over controller\'s components', error.stack);
    }


  }
}
